import { useTranslation } from 'react-i18next';
import { useStore } from 'zustand';
import { userOverviewStore } from 'entities/userOverview';
import { useDebounceFunction } from 'shared/lib/debounce';
import { SearchInput } from 'shared/ui/SearchInput';

const UserSearchInput: React.FC = () => {
  const { t } = useTranslation();

  const { setSearchQuery } = useStore(userOverviewStore);
  const debouncedSearchHandler = useDebounceFunction(setSearchQuery, 500);

  return (
    <SearchInput
      onChange={(e) => debouncedSearchHandler(e.currentTarget.value)}
      placeholder={t('UserOverview:UserTable.UserSearchInput.placeholder')}
    />
  );
};

export default UserSearchInput;
